import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=7587e5b4&scoped=true"
import script from "./advertising.vue?vue&type=script&lang=js"
export * from "./advertising.vue?vue&type=script&lang=js"
import style0 from "./advertising.vue?vue&type=style&index=0&id=7587e5b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7587e5b4",
  null
  
)

export default component.exports